'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = exports.init = exports.setup = void 0;
var shared_1 = require("@cian/peperrors/shared");
var system_js_1 = require("./sources/system.js");
var index_js_1 = require("../shared/index.js");
var index_js_2 = require("../shared/sources/index.js");
var setupConfigParams = null;
var config = null;
/**
 * @deprecated конфиг самоинициализируется, вызов этого метода можно удалить
 *
 * @export
 * @param {IBrowserConfigParams} params
 */
function setup(params) {
    setupConfigParams = params;
}
exports.setup = setup;
function init() {
    if (!config) {
        config = loadConfig();
    }
    return config;
}
exports.init = init;
function getConfig() {
    if (!config) {
        throw new shared_1.ConfigurationError({
            message: 'Config must be created before accessing it. Forgot to call init() before accessing config?',
            domain: 'config.getConfig',
        });
    }
    return config;
}
exports.getConfig = getConfig;
function initDump(projectName) {
    if (!window._cianConfig) {
        window._cianConfig = {};
    }
    var store = window._cianConfig;
    if (!store[projectName]) {
        store[projectName] = [];
    }
    var dump = store[projectName];
    if (!dump.watcher) {
        dump.watcher = document.createElement('span');
        dump.push = dumpPush;
        dump.concat = dumpConcat;
    }
    function dumpPush() {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = Array.prototype.push.apply(this, args);
        (_a = this.watcher) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('update', { detail: this }));
        return result;
    }
    function dumpConcat() {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = Array.prototype.concat.apply(this, args);
        (_a = this.watcher) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent('update', { detail: result }));
        result.watcher = this.watcher;
        result.concat = dumpConcat;
        result.push = dumpPush;
        return result;
    }
    return dump;
}
function loadConfig() {
    var _a;
    var systemSource = new system_js_1.System(setupConfigParams);
    var matcher = new index_js_1.Matcher();
    var systemConfig = new index_js_1.Config({ source: systemSource, matcher: matcher });
    var projectName = systemConfig.getStrict('projectName');
    var dump = initDump(projectName);
    dump.forEach(function (setting) {
        if (!(0, index_js_1.validate)(setting)) {
            throw new shared_1.ValidationError({
                message: "Received unexpected entry in _cianConfig.".concat(projectName),
                domain: 'config.loadConfig',
                details: { setting: JSON.stringify(setting, null, 2) },
            });
        }
    });
    // TODO: Сейчас настройки передаются по ссылке, что небезопасно в случае микрофронтов
    var dumpSource = new index_js_2.SortedWritableSource(dump);
    // TODO: Для SPA-приложений нужно подумать об очистке подписок
    (_a = dump.watcher) === null || _a === void 0 ? void 0 : _a.addEventListener('update', function (e) {
        dumpSource.add(e.detail);
    });
    var config = new index_js_1.Config({ source: [systemSource, dumpSource], matcher: new index_js_1.Matcher() });
    return config.attach({
        requestId: systemConfig.get('requestId') || undefined,
    });
}
//# sourceMappingURL=interface.js.map
